import { mainnet, pulsechain, pulsechainV4, sepolia } from 'wagmi/chains'

const chains: any = process.env.NEXT_PUBLIC_ENV == 'development' ? [pulsechainV4, sepolia] : [pulsechain, mainnet]

export default chains

export const initialChain = process.env.NEXT_PUBLIC_ENV == 'development' ? pulsechainV4 : pulsechain
